var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSimilarDoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_similar_doc"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_24823",
    "data-name": "\\uC0AC\\uAC01\\uD615 24823",
    width: 24,
    height: 24,
    fill: "#f1f1f1",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_10733",
    "data-name": "\\uD328\\uC2A4 10733",
    d: "M474.687,376.963a.3.3,0,0,0-.027-.04.408.408,0,0,0-.071-.1l-.008-.009-3.933-3.5a.342.342,0,0,0-.071-.043.3.3,0,0,0-.053-.032.413.413,0,0,0-.155-.032h-3.913a12.13,12.13,0,0,0-3.587,3.215v8.99a1.922,1.922,0,0,0,1.894,1.792l.1,0h6.272a1.955,1.955,0,0,0,1.952-1.421,1.936,1.936,0,0,0,1.636-1.767V377.13A.412.412,0,0,0,474.687,376.963Zm-3.9-2.395,2.41,2.143h-1.278a1.069,1.069,0,0,1-1.132-.978Zm.366,11.8h-6.315a1.067,1.067,0,0,1-1.132-.978v-8.935a1.077,1.077,0,0,1,.735-.957v8.521a1.922,1.922,0,0,0,1.894,1.792l.1,0h5.733A1.113,1.113,0,0,1,471.156,386.372Zm1.574-1.4h-6.316a1.064,1.064,0,0,1-1.132-.978v-8.935a1.087,1.087,0,0,1,1.1-1.008h3.573v1.706a1.921,1.921,0,0,0,1.894,1.793l.1,0h1.94v6.431A1.093,1.093,0,0,1,472.73,384.974Z",
    transform: "translate(-456.87 -368.213)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSimilarDoc);
export default __webpack_public_path__ + "static/media/icon_similar_doc.c96c5c5120ea2508797d22db838415f1.svg";
export { ForwardRef as ReactComponent };